export const resumePDFStyleCSS = `
body {
    font-family: "Roboto", Arial, Helvetica, sans-serif;
}

.textSection {
	padding: 20px;
	background: #fff;
}

.textSection ul {
	padding-left: 0;
	list-style: none;
	margin: 5px 0 30px;
}
.textSection ul li {
	padding-left: 15px;
	position: relative;
	margin-bottom: 10px;
	font-family: 'Roboto', 'Helvetica Neue', Arial;
	font-size: 16px;
	font-weight: 400;
	color: #0a0a0a;
	line-height: 20px;
	vertical-align: baseline;
	-webkit-font-smoothing: antialiased !important;
}
.textSection ul li::before {
	content: '';
	position: absolute;
	width: 4px;
	height: 4px;
	top: 7px;
	left: 2px;
	border-radius: 50%;
	background-color: #0054a6; 
}
.textSection ul li ul {
	margin: 10px 0 20px 15px;
}


.subTitle {
	font-size: 22px;
	margin: 16px 0 30px 0;
	color: #222d65;
	line-height: 22px;
	padding: 0;
	font-weight: 700;
}

.infoTitle {
	margin: 5px 0px;
}
.infoTitle:first-child {
	margin-top: 0px;
}
.infoTitle span {
	display: block;
	margin: 0px 0px 15px;
}

.collapseBorderBottom {
	border-bottom: 1px solid #ccc !important;
	padding-bottom: 10px;
}

hr {
	border: none;
	border-bottom: 1px solid #ccc;
} 

.policyLabel {
	font-size: 15px;
	padding-left: 5px;
	line-height: 17px;
	color: #0a0a0a;
}
.policyContainer {
	margin-top: -5px;
	margin-left: 20px;
}

.checkbox2Container {
	margin-bottom: 30px;
	margin-right: 15px;
}

.checkboxImage {
	width: 15px;
	height: 15px;
}


.noMargin {
    margin: 0px !important;
}

h6 {
    font-size: 17px !important;
    margin: 10px 0px !important;
	color:  #0054a6;
}

.answerURB {
    display: block;
    margin: 0px 0px 8px;
    white-space: normal;
}

p {
    margin: 0;
}

.answer {
    display: block;
    margin: 0px 0px 15px;
    white-space: normal;
}

h4 {
    font-size: 22px;
    line-height: 26px;
	margin-bottom: 20px;
	margin-top: 16px;
    color: #222d65;
}


h5 {
    font-weight: 600;
    color: #0054a6;
	font-size: 18px;
    margin: 10px 0px;
}
	
h3 {
	color: #222d65;
	font-size: 22px;
	margin: 0 0 30px 0;
}
	

.fileItem {
	padding: 10px;
	background: #f7f7f8;
	font-size: 12px;
    border: 1px solid #e6e7e8;
}

.fileItemDetails {
	align-items: center;
	width: 100%;
	padding: 0;
}

.fileItemName {
	padding: 0;
}

.fileSubtitle {
		margin-top: 0px !important;
		margin-bottom: 5px;
		padding: 0;
		font-weight: 700;
		font-size: 16px;
		line-height: 22px;
		color: #0a0a0a;
	}

.fileContainer {
	padding: 16px;
	border: 1px solid #ccc;
	border-radius: 8px;
	margin-bottom: 10px !important;
	margin-top: 10px !important;
}


`
